module.exports = __webpack_public_path__ + "img/providers.d4a856cc.webp";